import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SharedModule, FormInputComponent, StringCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
  template: `
      <select [formControl]="formControl" [vdrDisabled]="readonly">
          <option value="" disabled>Select {{label}}</option>
          <option *ngFor="let option of options;trackBy:trackByFn" [ngValue]="option.value">
              {{ option.label || option.value }}
          </option>
      </select>
  `,
  standalone: true,
  imports: [SharedModule],
  styles: [`
  select {
    margin-top: 15px;
    margin-bottom: 10px;
    width: 100%;
  }
  `]
})
export class OptionsSelectorFormComponent implements FormInputComponent<StringCustomFieldConfig>, OnInit {
  readonly: boolean;
  config: StringCustomFieldConfig;
  formControl: UntypedFormControl;

  constructor() {}

  ngOnInit() { }

  get options() {
    return this.config.ui?.options || this.config.options;
  }
  get label() {
    return this.config.ui?.label || this.config.name;
  }

  trackByFn(index: number, item: any) {
      return item.value;
  }
}
